var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PaginatedList',{attrs:{"actions":_vm.actions,"columns":_vm.columns,"populate":['documents', 'user'],"query":_vm.query,"no-results-message":"No KYC records to check.","service":"userProfile"}})}
var staticRenderFns = []

export { render, staticRenderFns }